import { worksMovies } from "@/mocks/worksMovies";
import { worksTv } from "@/mocks/worksTv";
import { worksVariety } from "@/mocks/worksVariety";
import { specials } from "@/mocks/specials";
import { homeBanners } from "@/mocks/banners";
import type { MediaType, Special, Work } from "@/types/media";

export const allWorks: Work[] = [
  ...(worksMovies as Work[]),
  ...(worksTv as Work[]),
  ...(worksVariety as Work[]),
];

export const allSpecials: Special[] = specials as Special[];

export const banners = homeBanners;

export function getWorkById(id: string | undefined): Work | undefined {
  if (!id) return undefined;
  return allWorks.find((w) => w.id === id);
}

export function getSpecialById(id: string | undefined): Special | undefined {
  if (!id) return undefined;
  return allSpecials.find((s) => s.id === id);
}

export function getWorksByType(type: string | undefined): Work[] {
  if (!type) return [];
  return allWorks.filter((w) => w.type === type);
}

export function getTypeLabel(type: MediaType): string {
  const map: Record<MediaType, string> = { movie: "电影", tv: "电视剧", variety: "综艺" };
  return map[type];
}

export interface WorkFilter {
  region?: string;
  year?: string;
  language?: string;
  genre?: string;
}

export function applyFilter(list: Work[], filter: WorkFilter): Work[] {
  return list.filter((w) => {
    if (filter.region && filter.region !== "全部" && w.region !== filter.region) return false;
    if (filter.year && filter.year !== "全部" && String(w.year) !== filter.year) return false;
    if (filter.language && filter.language !== "全部" && w.language !== filter.language) return false;
    if (filter.genre && filter.genre !== "全部" && !w.genres.includes(filter.genre)) return false;
    return true;
  });
}

export function sortWorks(list: Work[], sort: string): Work[] {
  const copy = [...list];
  if (sort === "rating") copy.sort((a, b) => b.rating - a.rating);
  else if (sort === "new") copy.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
  else copy.sort((a, b) => Number(b.hot) - Number(a.hot) || b.rating - a.rating);
  return copy;
}

export function searchWorks(keyword: string): Work[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allWorks.filter((w) => {
    const haystack = [
      w.title,
      w.director,
      ...w.actors,
      ...w.genres,
      ...w.tags,
      w.region,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function getRelated(work: Work, count = 6): Work[] {
  const scored = allWorks
    .filter((w) => w.id !== work.id)
    .map((w) => {
      let score = 0;
      if (w.type === work.type) score += 2;
      score += w.genres.filter((g) => work.genres.includes(g)).length * 3;
      score += w.actors.filter((a) => work.actors.includes(a)).length * 4;
      score += w.tags.filter((t) => work.tags.includes(t)).length;
      return { work: w, score };
    })
    .sort((a, b) => b.score - a.score || b.work.rating - a.work.rating);
  return scored.slice(0, count).map((s) => s.work);
}

export function getSpecialsForWork(work: Work): Special[] {
  return allSpecials.filter((s) => s.workIds.includes(work.id));
}